"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.list = exports.approve = exports.create = void 0;
const constants_1 = require("../constants");
function create(params) {
    return {
        data: params,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/group-requests/create`,
    };
}
exports.create = create;
function approve(params) {
    return {
        data: params,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/group-requests/approve`,
    };
}
exports.approve = approve;
function list(params) {
    return {
        data: params,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/group-requests/list`,
    };
}
exports.list = list;
//# sourceMappingURL=http.js.map